import BaseRepository from './base-repository';
import { CartEntity, CartParticipant } from '@/types/Cart';

export default class CartsRepository extends BaseRepository<CartEntity> {
   constructor(showId: string, cartId: string) {
      super(`/clfinder/shows/${showId}/carts/${cartId}`, 'id');
   }

   public sharing() {
      return this._get(this._resource + '/sharing', {});
   }

   public share(recipients: Array<string>) {
      return this._post(this._resource + '/share', recipients);
   }

   public unshare(recipients: Array<string>) {
      return this._post(this._resource + '/unshare', recipients);
   }
}
